import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

export default function ViewSelector() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container>
      <Button
        onClick={() => navigate("/kaart")}
        color={location?.pathname?.startsWith("/kaart") ? "blue" : "gray"}
      >
        Kaart
      </Button>
      <Button
        onClick={() => navigate("/lijst")}
        color={location?.pathname?.startsWith("/lijst") ? "blue" : "gray"}
      >
        Lijst
      </Button>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  left: 50vw;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
`;

const Button = styled.button`
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  background: ${({ color }) => (color === "blue" ? "#0075BC" : "white")};
  color: ${({ color }) => (color === "blue" ? "#FFFFFF" : "#212529")};

  font-family: "Roboto";
  font-weight: 700;
  font-size: 13px;
  line-height: 120%;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  width: 124.8px;
  height: 57px;
  margin-left: -4px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.1s, box-shadow 0.3s;

  &:hover {
    background-color: ${({ color }) =>
      color === "blue" ? "#005f8c" : "#f8f9fa"};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
  }

  &:active {
    background-color: ${({ color }) =>
      color === "blue" ? "#004d73" : "#e2e6ea"};
    transform: translateY(2px);
  }
`;
